<template>
    <div >   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
            class="box"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="a_xgw_category_id"
                    label="分类名称"
                    prop="a_xgw_category_id"
                    :help="formErr.a_xgw_category_id"
                    :validateStatus='!formErr.a_xgw_category_id||formErr.a_xgw_category_id==""?"":"error"'
            >
                <a-select v-model="form.a_xgw_category_id">
                    <a-select-option :value="item.id" :key="item.id" v-for="item in seleList.category"  >
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item
                    ref="name"
                    label="标题"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name||formErr.name==""?"":"error"'
            >
                <a-input
                        :maxLength=200
                        v-model="form.name"
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  form.name = e.target.value.trim();}"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="website"
                    label="网址"
                    prop="website"
                    :help="formErr.website"
                    :validateStatus='!formErr.website||formErr.website==""?"":"error"'
            >
                <a-input
                        v-model="form.website"
                        @change="(e) => { formErr.website=''}"
                        @blur="(e) => {  form.website = e.target.value.trim();}"
                />
            </a-form-model-item>

            <a-form-model-item
                    ref="cover"
                    label="封面"
                    prop="cover"
                    :extra="formErr.cover"
                    :validateStatus='!formErr.cover||formErr.cover==""?"":"error"'
            >
                <a-upload
                        :action="this.$store.state.urlChang"
                        :data="{type:1}"
                        :file-list="fileList"
                        :headers="headers"
                        @change="(file)=>{handleChange(file)}"
                        :before-upload="beforeUpload"
                        @preview="handlePreview"
                        list-type="picture-card"
                        name="file"
                >
                    <div v-if="fileList.length < 1">
                        <a-icon type="plus"/>
                        <div class="ant-upload-text">Upload</div>
                    </div>
                </a-upload>
                <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                    <img :src="previewImage" alt="example" style="width: 100%"/>
                </a-modal>
            </a-form-model-item>
            <a-form-model-item
                    ref="release_time"
                    label="发布时间"
                    prop="release_time"
                    :help="formErr.release_time"
                    :validateStatus='!formErr.release_time||formErr.release_time==""?"":"error"'
            >
                <a-date-picker  :format="dateFormat" show-time  v-model="form.release_time"/>
            </a-form-model-item>
            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
                <a-radio-group v-model="form.status"  >
                    <a-radio :value="item.value" :key="item.value" v-for="item in this.seleList.status"> {{item.name}} </a-radio>
                </a-radio-group>
            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import moment from 'moment';
    import API from "../api";
    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    export default {
        name: "videoForm",
        // props: ["visible","title","editId"],
        props: {
            visible:{type: Boolean,},
            title:{type: String,},
            editId:{type: [String, Number],},

        },
        data() {
            return {
                contenta: "",
                headers: {Authorization: window.sessionStorage.getItem("signature")},
                seleList:[],
                fileList:[],
                previewVisible: false,
                previewImage: "",
                drawerConfig ,
                dateFormat: 'YYYY-MM-DD HH:mm:ss',
                form: {
                    name:"",
                    a_xgw_category_id:"",
                    cover:"",
                    website:"",
                    release_time:moment(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    status:1,
                },
                formErr: {
                    name:"",
                    a_xgw_category_id:"",
                    cover:"",
                    website:"",
                    release_time:"",
                    status:"",
                },
                rules: {
                    a_xgw_category_id: [{required: true, message: "请输入分类 ",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.a_xgw_category_id)}  , trigger: "blur"  },],
                    name: [{required: true, message: "请输入标题 ",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  },],
                    website: [{required: true, message: "请输入网址 ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.website)}  , trigger: "blur"  },],
                    cover:[{required: true, message: " ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.cover)}  , trigger: "blur"  },],
                    release_time:[{required: true, message: "请输入发布时间 ",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.release_time)}  , trigger: "blur"  },],
                },
                layout: {
                    labelCol: { span:4},
                    wrapperCol: { span:16 },
                },
            };

        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA(a).then(res => {
                        let data=res.data.data.info
                        this.form = data
                        this.form.release_time=moment(res.data.data.info.release_time, 'YYYY-MM-DD HH:mm:ss')
                        if (this.form.cover == "") {
                            this.fileList = []
                        } else {
                            this.fileList = [
                                {uid: this.form.cover,
                                    name: this.form.cover,
                                    status: "done",
                                    url: this.form.cover ? this.form.cover : ""
                                }
                            ]
                        }
                        this.form.id=a
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        mounted(){
            this.getFormData()
        },
        methods: {
            getFormData(){
                API.service.ADD_DATA().then(res => {
                    this.seleList={
                        category:res.data.data.category,
                        status:res.data.data.status,
                    }
                })
            },
            handleCancel() {
                this.previewVisible = false;
            },
            handleChange(info ) {
                let {fileList} = info;
                const status = info.file.status;

                if (status !== 'uploading') {
                    this.fileList=[]
                }
                if (status === 'done') {
                    this.formErr.cover=""
                    this.fileList= fileList
                } else if (status === 'error') {
                }
                if (status === 'uploading') {
                    this.fileList= fileList
                }
                if (status=== 'done') {
                    getBase64(info.file.originFileObj, imageUrl => {
                        this.formErr.cover=""
                        this.fileList= fileList
                    });
                }
                //重新设置state
                // this.setState( {fileList});
            },
            beforeUpload(file) {
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
                if (!isJpgOrPng) {
                    this.$message.error('只能上传jpeg、jpg，png类型图片!');
                    return false
                }
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('图片必须小于 2MB!');
                    return false
                }
                return new Promise(function (resolve,reject) {
                    resolve(file)
                })
            },
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await getBase64(file.originFileObj);
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },
            onClose() {
                this.$emit("changVisible", false);
                this.fileList=[]
                this.form= {
                        name:"",
                        a_xgw_category_id:"",
                        cover:"",
                        website:"",
                        release_time:moment(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        status:1,
                },
                this.formErr={
                        name:"",
                        a_xgw_category_id:"",
                        cover:"",
                        website:"",
                        release_time:"",
                        status:"",
                },
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                let checks
                if (this.fileList.length < 1) {
                    _this.formErr.cover = "请上传封面";
                    // return
                } else {
                    _this.formErr.cover = "";
                    this.form.cover = this.fileList[0].url
                }
                if (this.fileList.length > 0 && this.fileList[0].url) {
                    this.form.cover = this.fileList[0].url
                } else if (this.fileList.length > 0 && this.fileList[0].response) {
                    this.form.cover = this.fileList[0].response.data.url
                } else {
                    this.form.cover = ""
                }
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        if(checks==false)return
                        let url
                        let subData=JSON.parse(JSON.stringify(this.form))
                        subData.release_time!=""?subData.release_time=moment(subData.release_time).format('YYYY-MM-DD HH:mm:ss'):subData.release_time=null
                        subData.id == '' || subData.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                        submitForm(url, subData).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
.box >>> .ant-form-extra{top:calc(100% - 30px) !important;position: absolute}
.box >>> .ant-form-item-control-wrapper{position: relative}
</style>
